export default __webpack_public_path__ + "static/media/ResetPassword.129f2ba6.less";